const content = {
  title: "Future Forms: will vs going to",
  explanation: `
At B1 level, both "will" and "going to" talk about the future, but speaker intention changes the choice.
Example: I will answer the phone. / I am going to study medicine.

Use "will" for instant decisions, promises, and spontaneous reactions.
Example: The bag looks heavy. I will carry it for you.

Use "going to" for prior plans and visible evidence-based predictions.
Example: We are going to move next month. / Look at the sky. It is going to storm.

In real communication, this contrast helps your future meaning sound precise and natural.
Example: I think she will like the gift, because I am going to choose something personal.
  `,
  rules: [
    "Use 'will' for decisions made at the moment of speaking",
    "Use 'will' for promises, offers, and quick reactions",
    "Use 'going to' for plans decided before speaking",
    "Use 'going to' for predictions based on clear evidence"
  ],
  examples: [
    "I’m tired. I will go to bed now. (decision made now)",
    "Don’t worry, I’ll help you. (offer)",
    "She is going to start a new job next month. (planned decision)",
    "Look at those dark clouds! It’s going to rain. (clear evidence)",
    "We are going to visit our grandparents this weekend."
  ]
};

export default content;


